import React, { useState } from 'react';

import { notification, Spin, Typography, List, Row, Col } from 'antd';
import { useIntl } from 'react-intl';

import {
  dialogFunction,
  StyledModal,
  InfoWithLabel,
  CustomNotification,
} from 'common/components';
import AplGrid from 'common/components/apl-grid/AplGrid';

import AddProductToAPLModalFooter from './AddProductToAPLModalFooter';
import ExistedProductApl from './ExistedProductApl';

import { useGlobalModal } from 'hooks';
import { useAddSelectedProductToApl } from 'hooks/apl/useAddProductToApl';

import messagesProduct from 'i18n/messages/product';

const AddProductToAPLModal = ({ selectedItemList }) => {
  const intl = useIntl();

  const [selectedApl, setSelectedApl] = useState(null);

  const { MODAL_NAMES, checkModalVisible, closeModal } = useGlobalModal();

  const modalVisible = checkModalVisible(MODAL_NAMES.ADD_TO_APL);

  const addSelectedProductToAplMutation = useAddSelectedProductToApl();

  const loading = addSelectedProductToAplMutation?.isLoading;

  const handleSubmitForm = async () => {
    try {
      const params = {
        aplId: selectedApl?.id,
        productIds: selectedItemList?.map((productItem) => productItem?.id),
      };

      const response = await addSelectedProductToAplMutation.mutateAsync(
        params
      );

      const { data, isSuccess } = response;

      if (isSuccess) {
        handleExistedProducts(data);

        if (!data?.productWithinApls?.length)
          CustomNotification.success(
            intl.formatMessage(messagesProduct.addProductToAplSuccess)
          );

        onCancel();
      } else {
        CustomNotification.error(
          response?.message ||
            intl.formatMessage(messagesProduct.addProductToAplError)
        );
      }
    } catch (error) {
      notification.error({
        message: 'Fail to Add Product to APL',
      });
    }
  };

  const handleExistedProducts = (data) => {
    if (!data) return;

    if (!data?.productWithinApls?.length) return;

    dialogFunction({
      type: 'info',
      cancelButtonProps: { style: { display: 'none' } },
      content: <ExistedProductApl productList={data?.productWithinApls} />,
    });
  };

  const onSelectApl = (selectedAplItem) => {
    setSelectedApl(selectedAplItem?.[0]);
  };

  const onCancel = () => {
    closeModal(MODAL_NAMES.ADD_TO_APL);
  };

  const submitBtnDisabled = !selectedApl;

  const modalProps = {
    title: intl.formatMessage(messagesProduct.addProductToAPLLabel),
    bodyStyle: { height: 'min(70vh, 500px)' },
    width: 1100,
    destroyOnClose: true,
    visible: modalVisible,
    maskClosable: false,
    closable: !loading,
    onCancel,
    footer: (
      <AddProductToAPLModalFooter
        disabled={submitBtnDisabled}
        loading={loading}
        onOk={handleSubmitForm}
        onCancel={onCancel}
      />
    ),
  };

  return (
    <StyledModal {...modalProps}>
      <div style={{ height: 468 }}>
        <AplGrid onSelectRow={onSelectApl} />
      </div>
    </StyledModal>
  );
};

export default AddProductToAPLModal;
